import { lazy } from 'react';

const CryptoDashboardApp = lazy(() => import('./CryptoDashboardApp'));

const CryptoDashboardAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/payments',
      element: <CryptoDashboardApp />,
    },
  ],
};

export default CryptoDashboardAppConfig;
